module.exports = __webpack_public_path__ + "static/media/wt-institution2.4356744b.png";